import { useTasksKanbanStore, useKanbanTaskShowApi, useTasksKanbanAgentsApi } from '@pages/tasks-kanban'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const id = to.params.id
  const tasksKanbanStore = useTasksKanbanStore()

  if (typeof id !== 'string' || !id) return

  tasksKanbanStore.clearTaskDetail()

  void useKanbanTaskShowApi({ id })
  void useTasksKanbanAgentsApi()
})
